import type { BaseComponentProps, WithChildren } from "@neru/types";
import { deduplicateClass } from "@neru/utils";

export const Layout = ({
  children,
  className,
}: BaseComponentProps & WithChildren) => (
  <div
    className={deduplicateClass(
      "box-border flex min-h-full flex-grow flex-col items-stretch bg-primary-0 p-8",
      className,
    )}
  >
    {children}
  </div>
);
